import React from 'react';
import { Field } from 'formik';
import { FormControl, FormGroup } from 'react-bootstrap';

interface Option<T> {
  value: T;
  label: string;
}

interface SelectDropdownProps<T> {
  name: string;
  label: string;
  values: any;
  errors: any;
  touched: any;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  options: Option<T>[];
  className?: string;
  placeholder?: string;
  setFieldValue?: (field: string, value: any, shouldValidate?: boolean) => void;
  disabled?: boolean;
}

export const SelectDropdown = <T extends string | number>({
  name,
  label,
  values,
  errors,
  touched,
  onChange,
  options,
  className = "textInput text-center primaryInput",
  placeholder,
  setFieldValue,
  disabled = false
}: SelectDropdownProps<T>) => {
  const getNestedValue = (obj: any, path: string) => {
    return path.split('.').reduce((o, i) => o?.[i], obj);
  };

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (setFieldValue) {
      setFieldValue(name, event.target.value);
    }
    onChange(event);
  };

  const currentValue = getNestedValue(values, name);

  return (
    <Field
      name={name}
      render={() => (
        <FormGroup controlId={name}>
          <div className="mb-2">
            <div style={{ fontSize: 14 }}>{label}</div>
          </div>
          <FormControl
            as="select"
            className={className}
            isInvalid={!!(errors[name] && touched[name])}
            value={currentValue ?? ''}
            onChange={handleChange}
            disabled={disabled}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((option) => (
              <option key={String(option.value)} value={option.value}>
                {option.label}
              </option>
            ))}
          </FormControl>
          {errors[name] && touched[name] ? (
            <small className="text-danger">{errors[name]}</small>
          ) : null}
        </FormGroup>
      )}
    />
  );
};

export default SelectDropdown; 